
export default function Logo({ className = "", inverted = false }: { className?: string; inverted?: boolean }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative w-10 h-10 flex items-center justify-center">
        {/* Éclair stylisé */}
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#10b981" />
              <stop offset="100%" stopColor="#3b82f6" />
            </linearGradient>
          </defs>
          {/* Cercle de fond */}
          <circle cx="20" cy="20" r="18" fill="url(#logoGradient)" opacity="0.15" />
          {/* Éclair LED */}
          <path 
            d="M22 8L14 22H20L18 32L26 18H20L22 8Z" 
            fill="url(#logoGradient)" 
            stroke={inverted ? "#ffffff" : "#10b981"}
            strokeWidth="1"
            strokeLinejoin="round"
          />
          {/* Cercles LED */}
          <circle cx="12" cy="12" r="1.5" fill={inverted ? "#ffffff" : "#3b82f6"} opacity="0.8" />
          <circle cx="28" cy="28" r="1.5" fill={inverted ? "#ffffff" : "#10b981"} opacity="0.8" />
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`text-xl font-black tracking-tight ${inverted ? 'text-white' : 'text-slate-900'}`}>
          POWER<span className="bg-gradient-to-r from-emerald-500 to-blue-500 bg-clip-text text-transparent">RENO</span>PRO
        </span>
        <span className={`text-[9px] font-semibold tracking-widest uppercase ${inverted ? 'text-emerald-300' : 'text-emerald-600'}`}>
          LED Solutions
        </span>
      </div>
    </div>
  );
}
